import React, { useEffect} from "react";
import { connect } from "react-redux";
import { Table } from 'antd';
import CrudOption from "components/dropdown/crudoption";
import { handleTableChange } from "../../../../../utils/index";
import { getEmployeeList } from "../../../../../redux/employee/employeeState";
import Badge from "components/badge";
import { EMPLOYMENT_STATUS_COLORS } from "variables/constants";
import ProfileDetails from "./ProfileDetails";
import SearchFilter from "components/search/SearchFilter";
import EmployeeAvatar from "./EmployeeAvatar";
import HeaderComponent from "components/card/HeaderComponent";
import ColumnSearchFilter from 'components/search/ColumnSearchFilter';
import { 
    getDepartmentList, getEmploymentStatusList
} from "../../../../../redux/optionlist/optionlistState";

const EmployeeDirectory = ({ 
    recordList, 
    pagination, 
    doSearch, 
    filters,
    departmentList,
    getDepartment,
    getEmploymentStatus,
    employmentStatusList
}) => {
    const { getColumnSearchProps } = ColumnSearchFilter();

    const columns = [
        {
            title: `Employee`,
            dataIndex: 'emp_employee_name',
            key: 'emp_employee_name',
            width: '25%',
            sorter: true,
            render:(_, record) => (
                <EmployeeAvatar
                    record={record}
                />
            ),
           
        },
        {
            title: `Position`,
            dataIndex: 'emp_title',
            key: 'emp_title',
            width: '20%',  
            sorter: true,
            ...getColumnSearchProps(['emp_title', 'emp_hire_date']),
            render: (emp_title) => (
				<span>{emp_title}</span>
			),
        },
        {
            title: 'Department',
            dataIndex: 'emp_department_name',
            key: 'emp_department_name',
            width: '15%',
            sorter: true,
            filters: departmentList
                ?.filter((dept) => dept.value !== 'all')
                .map((department) => ({
                    text: department.label,
                    value: department.value
			})) || [],
            render: (department_name) => (
				<span>{department_name}</span>
			),
        },
        {
            title: 'Team',
            dataIndex: 'emp_team_name',
            key: 'emp_team_name',
            width: '15%',
            sorter: true,
            ...getColumnSearchProps('emp_team_name'),
            render: (team_name) => (
				<span>{team_name}</span>
			),
        },
        {
            title: `Status`,
            dataIndex: 'emp_employment_status_id',
            key: 'emp_employment_status_id',
            width: '15%',
            sorter: true,
            filters: employmentStatusList?.map((employmentStatus) => ({
				text: employmentStatus.label,
				value: employmentStatus.value
			})) || [],
            render: (_, record) => (
				<Badge color={EMPLOYMENT_STATUS_COLORS[record?.employment_status_name]}>
					<span>{record?.employment_status_name}</span>
				</Badge>
			)
        },
        {
            title: 'Actions',
            dataIndex: 'emp_id',
            key: 'emp_id',
            width: '10%',
            render:(emp_id, record) => {
                return (
                    <CrudOption 
                        baseRoute="/console/employee-details" 
                        recordId={emp_id} 
                        allowDelete={false}  
                        allowEdit={false}
                        allowView={false}
                        allowDetail={true}
                        detailMode="modal"
                        detailHandler={() => {
                            return (
                                <ProfileDetails
                                    recordId={emp_id}
                                />
                            );
                        }}
                    />
                );
            }
        }
    ];

    useEffect(() => {
        getDepartment();
        getEmploymentStatus();
    }, [ getDepartment, getEmploymentStatus ]);
    
    useEffect(() => {
        doSearch({...filters, paginate: pagination.per_page});
    }, [doSearch, pagination.per_page]);

    return (
        <>
            <div className="w-full md:w-1/2">
                <div className="p-1">
					<SearchFilter 
						placeholder="Search by Employee Id or Name" 
						searchHandler={doSearch} 
						filters={filters} 
						pagination={pagination}
					/>
				</div>
            </div>
            <HeaderComponent
                title="Employee Directory"
            >
                <div className="relative w-full overflow-x-auto xl:overflow-x-hidden">
                    <Table
                        size="small"
                        dataSource={recordList} 
                        columns={columns}
                        scroll={{ x: "max-content" }}
                        rowKey={(record) => record.emp_id}
                        pagination={{...pagination, showTotal: (total, range) => `${range[0]} - ${range[1]} of ${total} records`,}}    
                        onChange={handleTableChange(doSearch, filters)}  
                    />
                </div>
            </HeaderComponent>
        </>
  );
};

const mapStateToProps = (state) => ({
    recordList: state.employee.employeeList?.items,
    pagination: state.employee.employeeList?.pagination,
    filters: state.employee.employeeList?.filters,
    requesting: state.employee.employeeList?.requesting,
    error: state.employee.employeeList?.error,
    employmentStatusList: state.optionlist.employmentStatusList?.items,
});

const mapDispatchToProps = (dispatch) => ({
    doSearch: (filters) => dispatch(getEmployeeList(filters)),
    getDepartment: (data) => dispatch(getDepartmentList(data)),
    getEmploymentStatus: (data) => dispatch(getEmploymentStatusList(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeDirectory);